export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 50
    },
    {
      prop: 'user_id',
      label: '小程序用户id',
      minWidth: 100
    },
    {
      prop: 'type',
      label: '发票类型',
      minWidth: 50,
    },
    {
      prop: 'real_name',
      label: '个人姓名',
      minWidth: 50,
    },
    {
      prop: 'mobile',
      label: '手机号',
      minWidth: 50,
    },
    {
      prop: 'email',
      label: '接收邮箱',
      minWidth: 50,
    },
    {
      prop: 'company_name',
      label: '企业发票抬头',
      minWidth: 50,
    },
    {
      prop: 'tax_number',
      label: '税号',
      minWidth: 50,
    },
    {
      prop: 'bank_name',
      label: '开户银行',
      minWidth: 50,
    },
    {
      prop: 'bank_account',
      label: '银行账号',
      minWidth: 50,
    },
    {
      prop: 'company_address',
      label: '企业地址',
      minWidth: 50,
    },
    {
      prop: 'company_phone',
      label: '企业电话',
      minWidth: 50,
    },
    // {
    //   prop: 'is_default',
    //   label: '默认',
    //   minWidth: 50,
    // },
    {
      prop: 'create_time',
      label: '创建时间',
      minWidth: 50,
    },
    {
      prop: 'update_time',
      label: '更新时间',
      minWidth: 50,
    },
    // {
    //   prop: "handle",
    //   label: "操作",
    //   minWidth: 50,
    // },
  ]
}


export default {}